<template>
    <master-layout>
        <div class="breadcamb_box">
            <div>
                <h4 class="page-title"><i class="ti-calendar"></i> {{ $t('calendar') }}</h4>
            </div>
            <pml-back-button></pml-back-button>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card-box">
                    <form @submit.prevent="doFilter()">
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15">
                                <label>{{ $t('status') }}</label>
                                <pml-multiselect v-model="filter.status_s" :options="status"></pml-multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-b-15">
                                <label>{{ $t('consultant') }}</label>
                                <pml-select-members v-model="filter.member_id" :options="members" label="full_name" :onlyActive="true"></pml-select-members>
                            </div>
                        </div>
                        <hr class="m-t-0">
                        <div class="clearfix text-center">
                            <span class="btn btn-white pull-left" @click.prevent="clear()"><i class="fa fa-paint-brush m-r-5"></i> {{ $t('clear') }}</span>
                            <router-link :to="{ name: 'calendar.create'}" class="btn btn-default">
                                <span class="btn-label">
                                    <i class="fa fa-plus-circle"></i>
                                </span>
                                {{ $t('task') }}
                            </router-link>
                            <button class="btn btn_green pull-right" type="submit">
                                <span class="btn-label">
                                    <i class="fa fa-search"></i>
                                </span>
                                {{ $t('filter') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="bg_white m-b-20" v-pml-block="isLoading">
                    <pml-fullcalendar @changeMonth="doFilter" :events="list"></pml-fullcalendar>
                </div>
            </div>
        </div>
    </master-layout>
</template>

<script>
    import moment from 'moment'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { mapGetters } from 'vuex'
    import { getAll } from 'services/calendar'
    import { isNull } from 'lodash'
    import { utcToLocal } from 'utils/helpers/dates'

    export default {
        name: 'Calendar',
        data () {
            return {
                filter: {
                    due_date_at_from: null,
                    due_date_at_to: null,
                    member_id: null,
                    status_s: null,
                    orderBy: 'due_date_at',
                    orderDirection: 'asc'
                },
                records: [],
                isLoading: false
            }
        },
        metaInfo () {
            return {
                title: trans('calendar')
            }
        },
        computed: {
            ...mapGetters({
                'members': 'getMembers',
                'member': 'getMember',
                'status': 'getTaskStatus'
            }),
            list () {
                return this.records.map((obj, i) => {
                    obj.start = utcToLocal(obj.start, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                    obj._id = obj.id || i
                    obj.end = obj.end || obj.start

                    return obj
                })
            }
        },
        mounted () {
            this.filter.due_date_at_from = moment().startOf('month').format('DD[/]MM[/]YYYY')
            this.filter.due_date_at_to = moment().endOf('month').format('DD[/]MM[/]YYYY')
            this.filter.member_id = this.member.id
            this.filter.status_s = ['pending', 'done']
            this.doFilter()
        },
        methods: {
            doFilter (start = null, end = null, currentStart = null) {
                this.isLoading = true
                if (!isNull(currentStart)) {
                    this.filter.due_date_at_from = moment(currentStart).startOf('month').format('DD[/]MM[/]YYYY')
                    this.filter.due_date_at_to = moment(currentStart).endOf('month').format('DD[/]MM[/]YYYY')
                }
                getAll(this.filter)
                    .then(response => { this.records = response.data })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isLoading = false })
            },
            clear () {
                this.filter.due_date_at_from = moment().startOf('month').format('DD[/]MM[/]YYYY')
                this.filter.due_date_at_to = moment().endOf('month').format('DD[/]MM[/]YYYY')
                this.filter.member_id = this.member.id
                this.filter.status_s = ['pending', 'done']
                this.doFilter()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/calendar/components/Main.vue